/**
 * Wat er op het scherm komt als het verwerken van een gesprek is misgegaan.
 *
 * De opgeslagen reden is de foutmelding zoals hij ontstond, en die is niet voor
 * een buddy geschreven: "Failed to start container: Maximum number of running
 * container instances exceeded" zegt hem niets, en het advies dat er ooit vast
 * bij stond — verwijder het gesprek en probeer opnieuw — was in dat geval
 * precies verkeerd. De opname mankeerde niets; er was even geen plek vrij.
 *
 * Elke zin hieronder is geschreven om twee dingen te zeggen: wat er aan de hand
 * is, en of de buddy er zelf iets aan kan doen. Wat er niet in staat is even
 * belangrijk: geen foutcodes, geen namen van diensten, geen advies om iets weg
 * te gooien dat nog goed is.
 *
 * Het staat in shared en niet in de Worker omdat de vertaalslag ook nodig is
 * voor gesprekken die vóór deze wijziging zijn mislukt: daar staat de ruwe
 * Engelse tekst nog in de database.
 */
const OORZAKEN = [
    {
        // Alle plekken bezet. Lost zichzelf op zodra een andere opname klaar is.
        patroon: /maximum number of running container instances|failed to start container/i,
        tekst: 'Er waren te veel opnames tegelijk bezig. Hier hoef je niets voor te doen — probeer het over een paar minuten opnieuw.',
    },
    {
        patroon: /na omzetting nog|accepteert 25 MB/i,
        tekst: 'De opname is te lang om in één keer uit te schrijven. Knip hem in delen van hooguit twee uur.',
    },
    {
        patroon: /omzetten van de opname mislukt/i,
        tekst: 'De opname kon niet worden omgezet. Waarschijnlijk is het bestand beschadigd of niet volledig geüpload.',
    },
    {
        patroon: /nog geen media|genormaliseerde audio niet gevonden/i,
        tekst: 'De opname is niet helemaal aangekomen. Upload hem opnieuw.',
    },
    {
        patroon: /transcriptie mislukt|ai gateway|geen leesbaar antwoord|ongeldige json/i,
        tekst: 'De dienst die de opname uitschrijft gaf geen bruikbaar antwoord. Dat ligt niet aan de opname; probeer het later opnieuw.',
    },
    {
        patroon: /duurde te lang|vastgelopen/i,
        tekst: 'Het verwerken is halverwege blijven steken. Probeer het opnieuw.',
    },
];
/** Wat er staat als we de oorzaak niet herkennen. Bewust zonder advies om het
 *  gesprek weg te gooien: dat is zelden het juiste antwoord en nooit terug te
 *  draaien. */
export const ALGEMENE_VERWERKINGSFOUT = 'Er ging iets mis bij het verwerken van dit gesprek.';
/** Wat er staat als de verwerking het opgeeft. De admins krijgen dan een mail
 *  met de echte foutmelding. */
export const VERWERKING_OPGEGEVEN = 'Het verwerken van deze opname is niet gelukt. De admins zijn op de hoogte.';
/** Wat al leesbaar is. De Workflow slaat de vertaalde reden op en de lijst
 *  vertaalt bij het tonen nog eens; zonder dit werd elke reden de algemene. */
const AL_LEESBAAR = new Set([
    ...OORZAKEN.map((o) => o.tekst),
    VERWERKING_OPGEGEVEN,
    ALGEMENE_VERWERKINGSFOUT,
]);
export function leesbareFout(ruw) {
    const tekst = (ruw ?? '').trim();
    if (!tekst)
        return ALGEMENE_VERWERKINGSFOUT;
    if (AL_LEESBAAR.has(tekst))
        return tekst;
    return OORZAKEN.find((o) => o.patroon.test(tekst))?.tekst ?? ALGEMENE_VERWERKINGSFOUT;
}
